const TOKEN_KEY = "hom_customer_session_token";
const EMAIL_KEY = "hom_customer_session_email";

export function setCustomerSession(token, email) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
  if (email) localStorage.setItem(EMAIL_KEY, email.toLowerCase().trim());
  else localStorage.removeItem(EMAIL_KEY);
}

export function clearCustomerSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
}

export function getCustomerSession() {
  const token = localStorage.getItem(TOKEN_KEY);
  const email = localStorage.getItem(EMAIL_KEY);
  if (!token || !email) return null;
  return { token, email };
}

export function sessionMatchesEmail(email) {
  const s = getCustomerSession();
  if (!s || !email) return false;
  return s.email === String(email).trim().toLowerCase();
}
